export default {
    name: 'regionCulture',
    serverName: '​/api/v1/normative_calculator/region_culture/',
    apiNormUrl: '/api/v1/normative_calculator/region_culture/',
    apiRBUrl: '/api/v1/rb_calculator/region_culture/'
};
